export default "__VITE_ASSET__0aca07fe__"